import React, { useState, useEffect } from 'react'
import Loader from '../../Components/Loader/Loader'
import Footer from '../../Components/Footer/Footer'
import Header from '../../Components/Header/Header'
import VoruSliceZone from '../../Components/VoruSliceZone/VoruSliceZone/SliceZone'
import PageTitle from '../../Components/PageTitle/PageTitle'

import './VoruPage.scss'

export default function VoruPage(props) {
  const {
    prismicCtx,
    match,
    footerHeight,
    setFooterHeight
  } = props

  const [doc, setDoc] = useState(null)
  const [notFound, setNotFound] = useState(false)


  useEffect(() => {
    async function fetch() {
      if (prismicCtx) {
        prismicCtx.api.getByUID('vorur', match.params.uid).then(doc => {
          if (doc) {
            setDoc(doc)
          } else {
            setNotFound(true)
          }
        })
      }
    }

    fetch()
  }, [prismicCtx, match.params.uid])

  if (notFound) {
    return <p>404</p>
  } else if (doc) {
    return (

      <div className='voruPage__wrapper'>
        <Header prismicCtx={prismicCtx} />
        <div className='voruPage__container' style={{paddingBottom: footerHeight+100}}>
          <div style={{ maxWidth: 1400, background: 'white', height: '100%', padding: '30px 20px', margin: 'auto'}}>
            <PageTitle text={doc.data.voruheiti[0].text}/>
            <VoruSliceZone
              prismicCtx={prismicCtx}
              slices={doc.data.body}
            />
          </div>

        </div>

        <Footer prismicCtx={prismicCtx} setFooterHeight={setFooterHeight}/>
      </div>
    )
  } else {
    return <Loader />
  }
}